// API base URL: npm start → local (.env); npm run build → production (.env.production)
// See .env (local) and .env.production (https://api.endosurgery.com.my/api/v1)
export const API_BASE_URL =
  import.meta.env?.VITE_API_BASE_URL || "http://localhost:8090/api/v1";

export async function getJson(path, options = {}) {
  const url = `${API_BASE_URL}${path}`;

  const response = await fetch(url, {
    headers: {
      "Content-Type": "application/json",
      ...(options.headers || {}),
    },
    ...options,
  });

  if (!response.ok) {
    throw new Error(`Request failed with status ${response.status}`);
  }

  const json = await response.json();
  // Backend wraps data in { status, message, message_code, data }
  return json?.data ?? null;
}

